import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Button, IconButton, Input, InputAdornment, InputLabel, styled, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { useAuth } from "../AuthProvider";

const Login: React.FC = () => {
    const { t } = useTranslation();
    const [fieldValue, setFieldValue] = React.useState("");
    const [showPassword, setShowPassword] = React.useState(false);
    const { authenticate } = useAuth();

    const toggleShowPassword = () => {
        setShowPassword((prev) => !!prev);
    };

    const handleLogin = () => {
        authenticate(fieldValue);
    };

    return (
        <Container>
            <Typography style={{ marginBottom: 20 }}>{t("insert_password")}</Typography>
            <InputLabel>{t("password")}</InputLabel>
            <Input
                autoFocus
                margin="dense"
                value={fieldValue}
                type={showPassword ? "text" : "password"}
                fullWidth
                onChange={(e) => {
                    setFieldValue(e.target.value);
                }}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton onClick={toggleShowPassword} edge="end">
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                }
            />
            <Button onClick={handleLogin}>{t("login")}</Button>
        </Container>
    );
};

export default Login;

export const Container = styled("div")`
    padding: 30px;
`;
